import { FC } from 'react';

type Props = {
    message?: string;
};

const RecaptchaErrorMessage: FC<Props> = ({ message = 'Recaptcha failed' }) => {
    return <p className="recaptcha-error tw-mt-2 tw-text-sm tw-text-coral-600">{message}</p>;
};

export default RecaptchaErrorMessage;
